<template v-cloak>
  <div class="ma-4">
    <v-progress-linear
      v-model="value"
      :active="show"
      :indeterminate="query"
      :query="true"
      color="cyan"
    ></v-progress-linear>
    <v-card
      class="overflow-y-auto pa-6"
      max-height="auto"
    >
      <v-layout row wrap>
        <!-- Client Reports Column -->
        <v-flex xs12 sm4 class="pa-2">
          <!-- Client Reports Card -->
          <v-card>
            <h3 class="primary text-center text-uppercase font-weight-light pa-2 white--text">
              <v-icon class="mr-2 white--text">supervisor_account</v-icon>
              Client Reports
            </h3>
            <v-divider></v-divider>

            <v-expansion-panels multiple>
              <v-expansion-panel
                v-for="(reportCategory, index) in filteredReports"
                :key="index"
              >
                <v-expansion-panel-header>
                  <span class="font-weight-bold">{{ reportCategory.Title }}</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list two-line>
                    <v-list-item-group active-class="blue--text" v-model="selected" multiple>
                      <v-list-item
                        v-for="(report, subIndex) in reportCategory.Subcategories"
                        :key="subIndex"
                        router :to="report.Route"
                        class="subcategory-item"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ report.Title }}</v-list-item-title>
                          <v-list-item-subtitle>{{ report.Description }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>

          <!-- Vehicle Reports Card directly below Client Reports -->
          <v-card class="mt-4" v-if="Role !== 'House Manager' && Role !== 'Assistant Manager'">
            <h3 class="primary text-center text-uppercase font-weight-light pa-2 white--text">
              <v-icon class="mr-2 white--text">directions_car</v-icon>
              Vehicle Reports
            </h3>
            <v-divider></v-divider>

            <v-expansion-panels multiple>
              <v-expansion-panel
                v-for="(reportCategory, index) in vehicleReports"
                :key="index"
              >
                <v-expansion-panel-header>
                  <span class="font-weight-bold">{{ reportCategory.Title }}</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list two-line>
                    <v-list-item-group active-class="blue--text" v-model="selected" multiple>
                      <v-list-item
                        v-for="(report, subIndex) in reportCategory.Subcategories"
                        :key="subIndex"
                        router :to="report.Route"
                        class="subcategory-item"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ report.Title }}</v-list-item-title>
                          <v-list-item-subtitle>{{ report.Description }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>

        </v-flex>

        <!-- Staff Reports and Programs Column -->
        <v-flex xs12 sm4 class="pa-2" v-if="Role !== 'Assistant Manager'">
          <!-- Staff Reports Card -->
          <v-card>
            <h3 class="primary text-center text-uppercase font-weight-light pa-2 white--text">
              <v-icon class="mr-2 white--text">badge</v-icon>
              Staff Reports
            </h3>
            <v-divider></v-divider>

            <v-expansion-panels multiple>
              <v-expansion-panel
                v-for="(reportCategory, index) in sortedStaffReports"
                :key="index"
              >
                <v-expansion-panel-header>
                  <span class="font-weight-bold">{{ reportCategory.Title }}</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list two-line>
                    <v-list-item-group active-class="blue--text" v-model="selected" multiple>
                      <v-list-item
                        v-for="(report, subIndex) in reportCategory.Subcategories"
                        :key="subIndex"
                        router :to="report.Route"
                        class="subcategory-item"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ report.Title }}</v-list-item-title>
                          <v-list-item-subtitle>{{ report.Description }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>

          <!-- Programs Card -->
          <v-card class="mt-4">
            <h3 class="primary text-center text-uppercase font-weight-light pa-2 white--text">
              <v-icon class="mr-2 white--text">widgets</v-icon>
              Programs
            </h3>
            <v-divider></v-divider>

            <v-expansion-panels multiple>
              <v-expansion-panel
                v-for="(reportCategory, index) in programs"
                :key="index"
              >
                <v-expansion-panel-header>
                  <span class="font-weight-bold">{{ reportCategory.Title }}</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list two-line>
                    <v-list-item-group active-class="blue--text" v-model="selected" multiple>
                      <v-list-item
                        v-for="(report, subIndex) in reportCategory.Subcategories"
                        :key="subIndex"
                        router :to="report.Route"
                        class="subcategory-item"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ report.Title }}</v-list-item-title>
                          <v-list-item-subtitle>{{ report.Description }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 class="pl-3 pr-2 pa-3">
          <v-layout row wrap>
            <v-flex xs12 class="pa-2" v-if="Role !== 'Assistant Manager'">
              <v-card>
                <h3 class="primary text-center text-uppercase font-weight-light pa-2 white--text">
                  <v-icon class="mr-2 white--text">people</v-icon>
                  HR Reports
                </h3>
                <v-divider></v-divider>

                <v-expansion-panels multiple>
                  <v-expansion-panel
                    v-for="(reportCategory, index) in hrReports"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      <span class="font-weight-bold">{{ reportCategory.Title }}</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list two-line>
                        <v-list-item-group active-class="blue--text" v-model="selected" multiple>
                          <v-list-item
                            v-for="(report, subIndex) in reportCategory.Subcategories"
                            :key="subIndex"
                            router :to="report.Route"
                            class="subcategory-item"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{ report.Title }}</v-list-item-title>
                              <v-list-item-subtitle>{{ report.Description }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-card>
                <h3 class="primary text-center text-uppercase font-weight-light pa-2 white--text">
                  <v-icon class="mr-2 white--text">work</v-icon>
                  ADMIN REPORTS
                </h3>
                <v-divider></v-divider>

                <v-expansion-panels multiple>
                  <v-expansion-panel
                    v-for="(reportCategory, index) in adminReports"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      <span class="font-weight-bold">{{ reportCategory.Title }}</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list two-line>
                        <v-list-item-group active-class="blue--text" v-model="selected" multiple>
                          <v-list-item
                            v-for="(report, subIndex) in reportCategory.Subcategories"
                            :key="subIndex"
                            router :to="report.Route"
                            class="subcategory-item"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{ report.Title }}</v-list-item-title>
                              <v-list-item-subtitle>{{ report.Description }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-flex>

            <v-flex xs12 class="pa-2" v-if="state === 'Nevada' && Role !== 'Assistant Manager'" >
              <v-card>
                <h3 class="primary text-center text-uppercase font-weight-light pa-2 white--text">
                  <v-icon class="mr-2 white--text">receipt</v-icon>
                  NEVADA BILLING
                </h3>
                <v-divider></v-divider>

                <v-expansion-panels multiple>
                  <v-expansion-panel
                    v-for="(reportCategory, index) in nevadaBilling"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      <span class="font-weight-bold">{{ reportCategory.Title }}</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list two-line>
                        <v-list-item-group active-class="blue--text" v-model="selected" multiple>
                          <v-list-item
                            v-for="(report, subIndex) in reportCategory.Subcategories"
                            :key="subIndex"
                            router :to="report.Route"
                            class="subcategory-item"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{ report.Title }}</v-list-item-title>
                              <v-list-item-subtitle>{{ report.Description }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
    <Foot/>
  </div>
</template>
<script>
import axios from 'axios'
// import moment from 'moment'
import Foot from '../components/Footer.vue'

const url = require("../client_config/config").url;

export default {
  components: {
    Foot,
  },
  data: () => ({
    value: 0,
    query: false,
    show: true,
    interval: 0,
    clients: [],
    startDate: "",
    endDate: "",
    ClientID: '',
    State: localStorage.getItem('userState'),
    Role: localStorage.getItem('userRole'),
    calendarMenu: false,
    calendar2Menu: false,
    report: '',
    clientName: '',
    main: true,
    showIncidents: false,
    showVisits: false,
    showAttendance: false,
    showBehaviors: false,
    selected: "",
    state: localStorage.getItem('userState'),
    reports: [
      {
        Title: 'REPORTS',
        Subcategories: [
          {Title: 'INCIDENT REPORT', Description: 'Shows Incidents for Last Month', Route: '/IncidentReport'},
          {
            Title: 'NV INCIDENT REPORT',
            Description: 'Shows Incidents for Last Month',
            Route: '/NVIncidentReport'
          },
          {
            Title: 'INCIDENT REPORT GRAPH',
            Description: 'View Incident Report Graph of Clients',
            Route: '/IncidentReportGraph'
          },
          {Title: 'ATTENDANCE', Description: 'Attendance for Clients', Route: '/AttendanceReport'},
          {Title: 'BEHAVIOR REPORT', Description: 'View Behaviors of Clients', Route: '/ReportingBehaviors'},
          {
            Title: 'UPCOMING EVENTS REPORT',
            Description: 'View Clients Upcoming Event',
            Route: '/UpcomingEventsReport'
          },
          {
            Title: 'CLIENT INVENTORY',
            Description: 'Client Inventory Report',
            Route: "/clientInventoryReport"
          },
          {
            Title: 'CLIENT ATTENDANCE',
            Description: 'Client Attendance Report',
            Route: "/clientAttendanceReport"
          },
        ],
      },
      {
        Title: 'MEDICAL',
        Subcategories: [
          {
            Title: 'MEDICAL VISITS',
            Description: 'Medical Visits for Last Month',
            Route: '/MedicalVisitsReport'
          },
          {
            Title: 'MEDICATION REVIEW REPORT',
            Description: 'Shows all Medication',
            Route: '/medication-report'
          },
          {
            Title: 'MISSING MEDICATION VERIFICATION',
            Description: 'Shows Medications That Have Not Been Verified',
            Route: '/MARVerified'
          },
          {
            Title: 'MONTHLY CLIENT MAR REPORT',
            Description: 'Shows clients MAR for the month',
            Route: '/MARReport'
          },
        ],
      },
      {
        Title: 'ONBOARD INFO',
        Subcategories: [
          {
            Title: 'EXPIRING CLIENT ANNUAL DOCUMENTS',
            Description: 'Shows Expiring Documents',
            Route: '/ExpiringDocuments'
          },
        ],
      },
      {
        Title: 'SERVICEPLAN/ADL\'S',
        Subcategories: [
          {Title: 'UNSIGNED ADLS REPORT', Description: 'View clients ADLS', Route: '/UnsignedADLReport'},
          {Title: 'ALL ADLS', Description: 'Search all client ADL\'S', Route: "/AllADL"},
        ],
      },
      {
        Title: 'CLIENT LIST',
        Subcategories: [
          {Title: 'CLIENT LIST', Description: 'List of All Active Clients', Route: "/ClientList"},
        ],
      },

      // {Title: 'ADLS REPORT', Description: 'View clients ADLS', Route: '/ADLReport'},
      // {Title: 'CLIENT FINANCES', Description: 'History of Client Finances', Route: '/FinancesReport'},
    ],

    staffReports: [
      {
        Title: 'INFORMATION',
        Subcategories: [
          {Title: 'STAFF REIMBURSEMENTS', Description: 'Pulls All Staff Reimbursements', Route: "/StaffExpenses"},
          {Title: 'STAFF INVENTORY', Description: 'Staff Inventory Report', Route: "/staffInventoryReport"},

        ],
      },
      {
        Title: 'CERTIFICATION',
        Subcategories: [
          {Title: 'STAFF CERTIFICATIONS', Description: 'Certifications by Staff and Status', Route: "/StaffExpiring"},
          {
            Title: 'CLIENT COMPETENCY TESTS',
            Description: 'Shows Completed Client Competency Tests',
            Route: "/CompTests"
          },
          {
            Title: 'INSERVICE TRAINING',
            Description: 'Lists All Training For Staff',
            Route: "/InserviceTrainingReport"
          },
          {
            Title: 'MISSED TRAINING',
            Description: 'Lists Of All Missed Training For Staff',
            Route: "/reports/missedTraining"
          },
          {
            Title: 'HISTORY OF TRAININGS',
            Description: 'Lists Of All Training For Staff',
            Route: "/reports/training-history"
          },
        ],
      },
      {
        Title: 'MAINTENANCE',
        Subcategories: [
          {Title: 'MAINTENANCE REQUEST', Description: 'Add Repairs for Houses', Route: "/HouseMaintenance"},
        ],
      },
      {
        Title: 'SHIFTS INFORMATION',
        Subcategories: [
          {Title: 'MISSING CLOCK INS', Description: 'View Missing Clock Ins', Route: "/missingClock"},
          {Title: 'MISSING CLOCK OUTS', Description: 'View Missing Clock Outs', Route: "/missingClockOut"},
          {Title: 'SHIFT REPORTS', Description: 'View client reports represented by staff', Route: "/shift-reports"},
        ],
      },
      {
        Title: 'LIST',
        Subcategories: [
          {Title: 'STAFF LIST', Description: 'List of All Active Staff', Route: "/StaffList"},],
      },
      {
        Title: 'VEHICLE',
        Subcategories: [
          {Title: 'VEHICLE INSPECTIONS', Description: 'Vehicle Inspection Report', Route: "/vehicleReport"},
        ],
      },
      // {Title: 'MISSING CERTIFICATIONS', Description: 'Missing Staff Certifications', Route: "/MissingCertifications"},
    ],

    hrReports: [
      {
        Title: 'SAFETY MANAGEMENT',
        Subcategories: [
          {Title: 'MONTHLY FIRE DRILLS BY PROGRAM', Description: 'Fire Drill', Route: "/MonthlyFire"},
          {Title: 'EVV', Description: 'Electronic Visit Verification', Route: "/EVVReport"},
        ],
      },
      {
        Title: 'COMPLIANCE & REGULATIONS',
        Subcategories: [
          {Title: 'LOCATIONS', Description: 'Location Addresses', Route: "/Locations"},
        ],
      },
      {
        Title: 'HUMAN RESOURCES',
        Subcategories: [
          {Title: 'TIME OFF REQUESTS', Description: 'Lists All Time Off Requests', Route: "/TimeOffRequests"},
        ],
      },
      {
        Title: 'PERFORMANCE',
        Subcategories: [
        {Title: 'PERFORMANCE REPORT', Description: 'Performance Report', Route: "/performance"},
        ],
      }
    ],

    adminReports: [
      {
        Title: 'ADMIN OPERATIONS',
        Subcategories: [
          {Title: 'BULK ATTENDANCE', Description: 'Add Attendance for Multiple Clients', Route: "/BulkAttendance"},
          // { Title: 'MONTHLY CHECKLIST', Description: 'Month End Checklist', Route: "/MonthlyChecklist" },
          // { Title: 'PERFORMANCE REVIEWS', Description: 'Get all the details for staff evaluation', Route: "/EmployeeEvaluation" }
        ]
      }
    ],

    vehicleReports: [
      {
        Title: 'VEHICLE MANAGEMENT',
        Subcategories: [
          {
            Title: 'VEHICLE MAINTENANCE REPORT',
            Description: 'View all Vehicle Maintenance for Company Vehicles',
            Route: "/VehicleMaintenanceReport"
          }
        ]
      }
    ],

    nevadaBilling: [
      {
        Title: 'BILLING AND CASE MANAGEMENT',
        Subcategories: [
          // { Title: 'BILLING REPORT', Description: 'Complete billing for clients', Route: "/NevadaBillingReport" },
          {Title: 'BILLING REPORT', Description: 'View Completed Billing for Clients', Route: "/Billing"},
          {Title: 'CASE MANAGEMENT', Description: 'Case Management Report', Route: "/CaseManagementReport"},
          {Title: 'JDT ATTENDANCE', Description: 'JDT Attendance Log Report', Route: "/JDTAttendanceReport"}
        ]
      },
      {
        Title: 'SERVICE LOGS',
        Subcategories: [
          {Title: 'ANCILLARY', Description: 'Ancillary Log Report', Route: "/AncillaryReport"},
          {
            Title: 'RESIDENTIAL SERVICE LOG',
            Description: 'Residential Service Log Report',
            Route: "/ResidentialServiceLog"
          }
        ]
      }
    ],

    programs: [
      {
        Title: 'PROGRAM REPORTS',
        Subcategories: [
          {Title: 'PROGRAMS REPORT', Description: 'View Programs Reports', Route: "/programs"}
        ]
      }
    ]
  }),

  computed: {
    sortedBillingReports() {
      return this.nevadaBilling.slice().sort((a, b) => a.Title.localeCompare(b.Title));
    },
    sortedHrReports() {
      return this.hrReports.slice().sort((a, b) => a.Title.localeCompare(b.Title));
    },
    sortedStaffReports() {
      return this.staffReports
        .slice()
        .sort((a, b) => a.Title.localeCompare(b.Title)) // Sort main reports by Title
        .map(report => ({
          ...report,
          Subcategories: report.Subcategories
            .slice()
            .sort((a, b) => a.Title.localeCompare(b.Title)) // Sort Subcategories alphabetically
        }));
    },
    filteredReports() {
      return this.reports
        .slice()
        .sort((a, b) => a.Title.localeCompare(b.Title)) // Sort main categories by Title
        .map((reportCategory) => {
          return {
            ...reportCategory,
            Subcategories: reportCategory.Subcategories
              .filter((report) => {
                // Filtering logic based on state
                if (this.State === 'Nevada' && (report.Title === 'INCIDENT REPORT' || report.Title === 'INCIDENT REPORT GRAPH')) {
                  return false;
                }
                if (this.State === 'Utah' && report.Title === 'NV INCIDENT REPORT') {
                  return false;
                }
                return true;
              })
              .sort((a, b) => a.Title.localeCompare(b.Title)), // Sort Subcategories alphabetically
          };
        });
    },
  },
  mounted() {
    this.queryAndIndeterminate()
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  created() {
    this.getClients();


  },

  methods: {
    queryAndIndeterminate() {
      this.query = true
      this.value = 0

      setTimeout(() => {
        this.query = false

        this.interval = setInterval(() => {
          if (this.value === 100) {
            clearInterval(this.interval)
            this.show = false
            return setTimeout(this.queryAndIndeterminate, 1000)
          }
          this.value += 25
        }, 1000)
      }, 2000)
    },
    initialize() {
      this.clients = [];
    },

    getClients() {
      axios.get(`${url}/clients`).then(async res => {
        this.clients = res.data.clients;

      });
    },
    close() {
      this.seditInfo = false;
      this.passdialog = false;
      this.chgimg = false;

    },

    togglePage() {
      if (this.main) {
        this.main = false

      }
    },

    // incidentQuery() {
    //   this.incidents = [],
    //   axios.get(`${url}/incidents/${this.ClientID}/${this.startDate}/${this.endDate}`).then(res => {
    //     this.incidents = res.data.incidents
    //   })
    // },
  }
}
</script>
<style>
@media only screen and (max-width: 480px) {

}
</style>
<style scoped>
.report-container {
  width: 80%;
  margin: auto;
}

.category-title {
  cursor: pointer;
  background-color: #f0f0f0;
  padding: 10px;
  border: 1px solid #ccc;
  margin-top: 10px;
  font-weight: bold;
}

.subcategory-item {
  margin-left: 20px; /* Indentation to differentiate subcategories */
  background-color: #f9f9f9; /* Lighter background to differentiate */
  border-left: 4px solid #3f51b5; /* Colored border for emphasis */
}

.subcategory-item .v-list-item-title {
  color: #3f51b5; /* Text color to match the border */
  font-weight: bold; /* Emphasize the subcategory */
}

.subcategory-item .v-list-item-subtitle {
  color: #757575; /* Make the subtitle less prominent */
  font-size: 0.9rem;
}

.v-expansion-panel-header {
  background-color: #e3f2fd; /* Light blue to highlight panel headers */
  font-weight: bold;
}

</style>

